export const setGetLocalData = (key, data) => {

    if (data) {
        sessionStorage.setItem(key, data);

    } else {
        sessionStorage.getItem(key);

    }
};


export const ClearLocalData = (key) => {
    console.log(key, "KeyClear")

    if (key) {
        // sessionStorage.removeItem(key);
    } else {
        sessionStorage.clear();
    }
};
